import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

// root state object.
// each Vuex instance is just a single state tree.
const state = {
    showFilters: false,
    filters: {},
    filtersInit: {},
    page: 1,
}

// mutations are operations that actually mutates the state.
// each mutation handler gets the entire state tree as the
// first argument, followed by additional payload arguments.
// mutations must be synchronous and can be recorded by plugins
// for debugging purposes.
const mutations = {
    page(state, page) {
        state.page = parseInt(page);
    },
    toggleSupportFilter(state) {
        state.showFilters = !state.showFilters;
    },
    filters(state, filters) {
        state.filters = filters;
    },
    resetFilters(state) {
        // Clear the filters of any values
        state.filters = _.mapValues(
            state.filters,
            function (value, key) {
                // all keys except 'page' to be empty
                return key == 'page' ? value : '';
            });
    },
}

// actions are functions that cause side effects and can involve
// asynchronous operations.
const actions = {
    confirmDelete({ commit }, id) {
        // TODO! Implement proper modal instead of JS alert/confirm
        if (confirm('You are about to delete this. Are you sure?')) {
            document.getElementById(id).submit();
        }
    },
    /**
     * For use in indices.
     *
     * Allows us to use the current filter state and append it as a ?previous=
     * parameter on the provided targetUrl. This then allows users to click
     * cancel, use the breadcrumbs etc without having to manually reset the
     * index filters to their previous state.
     *
     * @param  {commit} options.commit
     * @param  {state} options.state
     * @param  {string} targetUrl
     *
     * @return {void}
     */
    redirect({ commit, state }, targetUrl) {
        if (_.isEmpty(targetUrl)) {
            return alert('No link available.');
        }

        // Remove any empty filters
        let activeFilters = _.pickBy(state.filters, function (filter) {
            return !_.isEmpty(filter);
        });

        let currentUrl = location.href.replace(location.search, '');

        // Prepare the query params from the active filters
        let queryParams = $.param(activeFilters);

        // If they exist, append them to the current URL
        if (queryParams.length) {
            currentUrl += '?' + queryParams;
        }

        // Redirect the user
        window.location = targetUrl + '?previous=' + encodeURIComponent(currentUrl);
    },
}

// getters are functions
const getters = {

}

// A Vuex instance is created by combining the state, mutations, actions,
// and getters.
export default new Vuex.Store({
    state,
    getters,
    actions,
    mutations
})
